var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00244 17C2.00244 16.5858 2.33823 16.25 2.75244 16.25H9.25244C9.66666 16.25 10.0024 16.5858 10.0024 17C10.0024 17.4142 9.66666 17.75 9.25244 17.75H2.75244C2.33823 17.75 2.00244 17.4142 2.00244 17Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00244 12C2.00244 11.5858 2.33823 11.25 2.75244 11.25H15.2524C15.6667 11.25 16.0024 11.5858 16.0024 12C16.0024 12.4142 15.6667 12.75 15.2524 12.75H2.75244C2.33823 12.75 2.00244 12.4142 2.00244 12Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00244 7C2.00244 6.58579 2.33823 6.25 2.75244 6.25H21.2524C21.6667 6.25 22.0024 6.58579 22.0024 7C22.0024 7.41421 21.6667 7.75 21.2524 7.75H2.75244C2.33823 7.75 2.00244 7.41421 2.00244 7Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.e909cfee99c187e6091bbe100c6dad13.svg";
export { ForwardRef as ReactComponent };